// assign configurationModelName to each menu which has configurationModelId
export const transformMenusWithConfigurationModelName = (
  allMenus,
  allConfigurationModels
) => {
  const allConfigurationModelsUuids = allConfigurationModels?.map(
    ({ uuid }) => uuid
  )

  const menusWithConfigurationModelName = allMenus?.map((menu) => {
    if (
      allConfigurationModelsUuids?.includes(
        menu?.configurationModelId
      )
    ) {
      const configurationModel = allConfigurationModels?.find(
        ({ uuid }) => uuid === menu?.configurationModelId
      )

      return {
        ...menu,
        configurationModelName: configurationModel?.name,
      }
    }
    return {
      ...menu,
      configurationModelName: null,
    }
  })

  return menusWithConfigurationModelName
}
